(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funbed-promo-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('funbed-promo-banner')) {
  customElements.define('funbed-promo-banner', class extends HTMLElement {
    connectedCallback() {
      // Defer until all children exist, including when added in the theme editor.
      this.startTimer = window.setTimeout(() => {
        this.start();
        this.setupEffects();
      }, 0);
    }

    disconnectedCallback() {
      window.clearTimeout(this.startTimer);
      window.clearInterval(this.timer);
      this.cleanupEffects();
    }

    start() {
      window.clearInterval(this.timer);
      this.count = this.querySelector('[data-count]');
      this.expired = this.querySelector('[data-expired]');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
      if (!this.count || !this.expired || this.units.some(unit => !unit)) return;

      this.hidden = false;
      this.count.hidden = true;
      this.expired.hidden = true;
      const invalidNote = this.querySelector('[data-invalid]');
      const hiddenNote = this.querySelector('[data-hidden-note]');
      if (invalidNote) invalidNote.hidden = true;
      if (hiddenNote) hiddenNote.hidden = true;

      this.target = this.parseTarget();
      if (!Number.isFinite(this.target)) {
        if (invalidNote) invalidNote.hidden = false;
        return;
      }

      if (this.tick()) this.timer = window.setInterval(() => this.tick(), 1000);
    }

    parseTarget() {
      const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.dataset.date || '');
      const time = /^(\d{2}):(\d{2})$/.exec(this.dataset.time || '');
      if (!date || !time) return NaN;
      const [, year, month, day] = date.map(Number);
      const [, hour, minute] = time.map(Number);
      if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;

      // Validate the calendar date, then apply Turkey's UTC+03:00 explicitly.
      // The visitor's device timezone must not change the campaign deadline.
      const calendar = new Date(Date.UTC(year, month - 1, day, hour, minute));
      if (calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;
      return calendar.getTime() - 3 * 60 * 60 * 1000;
    }

    setupEffects() {
      this.cleanupEffects();
      this.canvas = this.querySelector('.funbed-promo__confetti');
      this.context = this.canvas ? this.canvas.getContext('2d') : null;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isInViewport = true;
      this.onMotionChange = () => this.syncEffects();
      this.motionPreference.addEventListener('change', this.onMotionChange);
      document.addEventListener('visibilitychange', this.onMotionChange);

      if (this.context) {
        this.resizeObserver = new ResizeObserver(() => this.resizeConfetti());
        this.resizeObserver.observe(this);
        this.resizeConfetti();
      }
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.isInViewport = entries[0].isIntersecting;
        this.syncEffects();
      });
      this.intersectionObserver.observe(this);
      this.syncEffects();
    }

    cleanupEffects() {
      window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.lastFrameTime = null;
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.motionPreference && this.onMotionChange) {
        this.motionPreference.removeEventListener('change', this.onMotionChange);
        document.removeEventListener('visibilitychange', this.onMotionChange);
      }
    }

    syncEffects() {
      const animate = this.isConnected && !this.hidden && !document.hidden &&
        this.classList.contains('funbed-promo--animated') &&
        !this.motionPreference?.matches && this.isInViewport !== false;
      this.classList.toggle('funbed-promo--paused', !animate);
      if (!this.context) return;
      if (!animate) {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.lastFrameTime = null;
        this.context.clearRect(0, 0, this.effectWidth, this.effectHeight);
      } else if (!this.animationFrame && this.effectWidth > 0 && this.effectHeight > 0) {
        this.animationFrame = window.requestAnimationFrame(time => this.drawConfetti(time));
      }
    }

    resizeConfetti() {
      const bounds = this.getBoundingClientRect();
      this.effectWidth = bounds.width;
      this.effectHeight = bounds.height;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(bounds.width * ratio);
      this.canvas.height = Math.round(bounds.height * ratio);
      this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
      const style = window.getComputedStyle(this);
      const colors = ['--fp-pink', '--fp-blue', '--fp-green', '--fp-yellow'].map(name => style.getPropertyValue(name).trim());
      colors.push('#ffffff', '#ff9db5');
      this.particles = Array.from({ length: Math.min(44, Math.round(bounds.width / 24)) }, () => ({
        x: Math.random() * bounds.width,
        y: Math.random() * (bounds.height + 20) - 20,
        size: 5 + Math.random() * 6,
        vy: 30 + Math.random() * 66,
        vx: -30 + Math.random() * 60,
        rotation: Math.random() * Math.PI * 2,
        spin: -4.8 + Math.random() * 9.6,
        sway: Math.random() * Math.PI * 2,
        color: colors[Math.floor(Math.random() * colors.length)],
        square: Math.random() < .5
      }));
      this.syncEffects();
    }

    drawConfetti(time) {
      const step = this.lastFrameTime == null ? 1 / 60 : Math.min((time - this.lastFrameTime) / 1000, .05);
      this.lastFrameTime = time;
      const ctx = this.context;
      ctx.clearRect(0, 0, this.effectWidth, this.effectHeight);
      this.particles.forEach(particle => {
        particle.sway += 1.8 * step;
        particle.x += (particle.vx + Math.sin(particle.sway) * 30) * step;
        particle.y += particle.vy * step;
        particle.rotation += particle.spin * step;
        ctx.save();
        ctx.translate(particle.x, particle.y);
        ctx.rotate(particle.rotation);
        ctx.fillStyle = particle.color;
        if (particle.square) {
          ctx.fillRect(-particle.size / 2, -particle.size / 2, particle.size, particle.size * .6);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, particle.size * .5, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
        if (particle.y > this.effectHeight + 20) {
          particle.y = -20;
          particle.x = Math.random() * this.effectWidth;
        }
      });
      this.animationFrame = window.requestAnimationFrame(nextTime => this.drawConfetti(nextTime));
    }

    tick() {
      const remaining = Math.ceil((this.target - Date.now()) / 1000);
      if (remaining <= 0) {
        window.clearInterval(this.timer);
        this.count.hidden = true;
        if (this.dataset.expiryAction === 'hide' && this.dataset.designMode !== 'true') {
          this.hidden = true;
          this.syncEffects();
        } else {
          this.expired.hidden = false;
          const hiddenNote = this.querySelector('[data-hidden-note]');
          if (hiddenNote && this.dataset.expiryAction === 'hide') hiddenNote.hidden = false;
        }
        return false;
      }

      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.units.forEach((unit, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (unit.textContent !== value) unit.textContent = value;
      });
      this.count.hidden = false;
      return true;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
